import { Fill, Stroke, Style } from 'ol/style';
import CircleStyle from 'ol/style/Circle';
const selectedStyles = {
    Point: new Style({
        image: new CircleStyle({
            radius: 6,
            fill: new Fill({ color: 'blue' }),
            stroke: new Stroke({ color: 'rgba(40,236,229,1)', width: 2 }),
        }),
    }),
    LineString: [
        new Style({
            stroke: new Stroke({ color: 'rgba(40,236,229,1)', width: 8 }),
        }),
        new Style({
            stroke: new Stroke({ color: 'blue', width: 6 }),
        }),
    ],
    Polygon: new Style({
        stroke: new Stroke({ color: 'rgba(40,236,229,1)', width: 2 }),
        fill: new Fill({ color: 'blue' }),
    }),
    MultiPolygon: new Style({
        stroke: new Stroke({ color: 'rgba(40,236,229,1)', width: 2 }),
        fill: new Fill({ color: 'blue' }),
    }),
};
export const selectStyle = function (feature) {
    // @ts-ignore
    return selectedStyles[feature.getGeometry().getType()];
};
